import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const LandingPageFooter = () => {
  return (
    <footer className="bg-[#4B0082] text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-3">
          <div className="flex justify-center mb-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_6ac808e2-e649-4b05-a358-945fa9e12d6d/artifacts/rbvzgu7l_logo-white.png" 
              alt="Trademark Frontline"
              className="h-10 w-auto"
            />
          </div>
          <p className="text-sm text-gray-300">
            &copy; {new Date().getFullYear()} Trademark Frontline. All rights reserved.
          </p>
          <div className="flex justify-center items-center gap-2 text-xs text-gray-300">
            <MapPin className="h-3 w-3" style={{ color: '#FF7F7F' }} />
            <span>515 Flower St, Los Angeles, CA 90071, USA</span>
          </div>
          <div className="flex justify-center items-center gap-4 text-xs">
            <Link 
              to="/privacy-policy" 
              className="text-gray-300 hover:text-[#FF7F7F] transition-colors underline"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-500">|</span>
            <Link 
              to="/terms-conditions" 
              className="text-gray-300 hover:text-[#FF7F7F] transition-colors underline"
            >
              Terms & Conditions
            </Link>
          </div>
          <p className="text-xs text-gray-400">
            Professional trademark registration services across the United States
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingPageFooter;
